import { render, staticRenderFns } from "./TransferSyllablesSchoolPreparing.vue?vue&type=template&id=42f89fde&lang=pug&"
import script from "./TransferSyllablesSchoolPreparing.vue?vue&type=script&lang=js&"
export * from "./TransferSyllablesSchoolPreparing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports